import { mapStyle } from "conts/mapbox";
import mapboxgl from "mapbox-gl";
import "mapbox-gl/dist/mapbox-gl.css";
import { useEffect, useRef } from "react";
import styled from "styled-components";
import { MarkerClassCard } from "ui/base/class/MarkerClassCard";
import { fonts, mediaSizes } from "ui/theme";

export const ClassLocation = ({classDetail}) => {
    const mapContainerRef = useRef(null);
    const teacher = classDetail?.teacher;
    const location =
        teacher?.lat && teacher?.lng ? [teacher?.lng, teacher?.lat] : null;

    useEffect(() => {
        if (!location || !mapContainerRef.current) return;

        const token = process.env.REACT_APP_MAPBOX_TOKEN;
        if (!token) {
            console.error("Mapbox token not found");
            return;
        }

        mapboxgl.accessToken = token;

        const map = new mapboxgl.Map({
            container: mapContainerRef.current,
            style: mapStyle,
            center: location,
            zoom: 13,
            scrollZoom: true,
            dragRotate: false,
            touchZoomRotate: true,
        });


        map.addControl(
            new mapboxgl.NavigationControl({
                showCompass: false,
                showZoom: true,
                visualizePitch: false,
            }),
            "top-right"
        );


        map.doubleClickZoom.enable();


        if (teacher) {
            const markerElement = document.createElement("div");
            markerElement.innerHTML = MarkerClassCard({
                classData: {
                    img: classDetail?.gallery?.[0]?.name,
                    rate: teacher?.rate,
                    review: teacher?.review,
                    title: teacher?.subject_sub_category,
                },
            });

            new mapboxgl.Marker({
                element: markerElement,
            })
                .setLngLat(location)
                .addTo(map);
        }

        return () => map.remove();
    }, [location, teacher, classDetail]);

    return (
        <ShowMapContainer>
            <TitleContainer>
                <Title>Location</Title>

                <p>
                    {teacher?.locations_of_class}
                    {teacher?.neighborhood ? ` | ${teacher.neighborhood}` : ""}
                </p>

            </TitleContainer>
            <MapContainer>
                {location ? <MapContent ref={mapContainerRef}/> : null}
            </MapContainer>
        </ShowMapContainer>
    );
};

const ShowMapContainer = styled.div`
    border-radius: 5px;
    width: 100%;
    display: grid;
    gap: 34px;
    font-family: var(--font-secondary);
`;

const TitleContainer = styled.div`
    display: grid;
    gap: 1.2rem;
    width: 100%;
    overflow-wrap: anywhere;
`;

const Title = styled.div`
    font-size: ${fonts.sizes.big};
    font-weight: 600;
    @media (width >= ${mediaSizes.md}) {
        font-size: ${fonts.sizes.h4};
    }
    @media (width >= ${mediaSizes.lg}) {
        font-size: ${fonts.sizes["h3.4"]};
    }
`;

const MapContainer = styled.div`
    width: 100%;
    height: 474px;
`;

const MapContent = styled.div`
    height: 100%;
    width: 100%;
    border-radius: 5px;

    .mapboxgl-map {
        border-radius: 5px;
    }

    .mapboxgl-ctrl-top-right {
        margin-top: 10px;
        margin-right: 10px;
    }

    .mapboxgl-canvas-container {
        cursor: grab;

        &:active {
            cursor: grabbing;
        }
    }
`;

